import React from "react"

export function Slider({checked, onChecked, disabled = false, className, style, ...rest}) {
  const mergedClassName = "slider-container" + (className != null ? ` ${className}` : "")

  const handleOnClick = () => {
    if (disabled || !onChecked) {
      return
    }

    onChecked(!checked)
  }

  return (
    <div className={mergedClassName} style={style} onClick={handleOnClick} {...rest}>
      <span className="slider" role="switch" aria-checked={checked} aria-disabled={!!disabled}/>
    </div>
  )
}